import { Popover } from 'antd';
import React, { FC } from 'react';

interface Props {
  text: string;
  limit: number;
  popover?: boolean;
}

export const TruncateString: FC<Props> = ({ text, limit, popover = true }) => {
  if (text && text.length > limit) {
    if (!popover) return text.substring(0, limit) + '...';

    return (
      <Popover zIndex={1060} content={text}>
        {text.substring(0, limit) + '...'}
      </Popover>
    );
  }
  return text;
};

export function formatToUppercaseWithHyphens(inputString: string): string {
  if (!inputString) {
    return '';
  }
  const uppercaseString = inputString.toUpperCase();
  const result = uppercaseString.replace(/ /g, '-');

  return result;
}

export function cn(...classes: (string | false | null | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}
